import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@shared/services/user.service';
import { GuardService } from '@shared/services/guard.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-language-toggle',
    templateUrl: './language-toggle.component.html',
    styleUrls: ['./language-toggle.component.scss'],
    standalone: false
})
export class LanguageToggleComponent implements OnInit, OnDestroy {
    selectedLanguage: string;
    subscription: Subscription;

    constructor(
        private translateService: TranslateService,
        private userService: UserService,
        private guardService: GuardService
    ) {}

    ngOnInit(): void {
        this.subscription = this.guardService.currentUserSubscribable.subscribe(
            e => (this.selectedLanguage = e?.settings?.language || 'en')
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    changeLanguage() {
        return this.userService.updateLanguage(this.translateService.currentLang === 'de' ? 'en' : 'de');
    }
}
